import { Component } from '@angular/core';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { setAuthModal } from '@state/auth/auth.actions';

@Component({
  selector: 'app-auth-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
})
export class SignInComponent {
  constructor(public store: Store<AppState>) {}

  openSignUp() {
    this.store.dispatch(setAuthModal({ authModal: 'signup' }));
  }
}
